import request from '@/utils/request';
export const defaultIInventoryInwardData = {
  id: 0,
  currentStock: 0,
  unitId: undefined,
  unit: {
    id: undefined
  },
  productId: undefined,
  product: {
    id: undefined
  },
  productsVariationId: undefined,
  productsVariation: {
    id: undefined
  }
};
export const getInventoryInwards = params => request({
  url: '/inventory-inwards/list',
  method: 'get',
  params
});
export const getInventoryInwardsOld = params => request({
  url: '/inventory-inwards',
  method: 'get',
  params
});
export const getInventoryInwardById = id => request({
  url: `/inventory-inwards/${id}`,
  method: 'get'
});
export const updateInventoryInward = (id, data) => request({
  url: `/inventory-inwards/${id}`,
  method: 'patch',
  data
});
export const deleteInventoryInward = id => request({
  url: `/inventory-inwards/${id}`,
  method: 'delete'
});
export const createInventoryInward = data => request({
  url: '/inventory-inwards',
  method: 'post',
  data
});
export const downloadInventoryInwardPdf = params => request({
  url: '/inventory-inwards/download-inventory-pdf',
  method: 'get',
  params
});
export const downloadExcelInventory = data => request({
  url: '/inventory-inwards/download-stock-excel',
  method: 'post',
  data,
  responseType: 'blob'
});